"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeReducer = void 0;
var PlaceState_init_1 = require("@/pages/place/states/PlaceState.init");
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var typesafe_actions_1 = require("typesafe-actions");
var NeighbourhoodReducer_1 = require("@/pages/place/reducers/NeighbourhoodReducer");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
var placeOnlyReducer = function (state, action) {
    if (state === void 0) { state = PlaceState_init_1.defaultPlaceState; }
    switch (action.type) {
        case typesafe_actions_1.getType(PlaceAction_1.default.showPop): {
            return __assign(__assign({}, state), { galleryPop: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setMapType): {
            return __assign(__assign({}, state), { mapType: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setSticky): {
            return __assign(__assign({}, state), { isSticky: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.changeDistrictInfo): {
            return __assign(__assign({}, state), { currentDistrictInfo: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setSort): {
            if (action.payload.filterType === SfilterTypeGroup_1.SfilterType.RENT) {
                return __assign(__assign({}, state), { availableRentSort: action.payload.field });
            }
            return __assign(__assign({}, state), { availableSaleSort: action.payload.field });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setOrder): {
            if (action.payload.filterType === SfilterTypeGroup_1.SfilterType.RENT) {
                return __assign(__assign({}, state), { availableRentOrder: action.payload.order });
            }
            return __assign(__assign({}, state), { availableSaleOrder: action.payload.order });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAvailableItemIsSaved): {
            var newResultsRent = state.availablePropertiesRent
                ? state.availablePropertiesRent.map(function (it) { return (Number(it.referenceId) === Number(action.payload.id)) ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; })
                : [];
            var newResultsSale = state.availablePropertiesSale
                ? state.availablePropertiesSale.map(function (it) { return (Number(it.referenceId) === Number(action.payload.id)) ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; })
                : [];
            return __assign(__assign({}, state), { availablePropertiesRent: newResultsRent, availablePropertiesSale: newResultsSale });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAvailableItemsIsSaved): {
            var ids_1 = action.payload.ids;
            var newResultsRent = state.availablePropertiesRent
                ? state.availablePropertiesRent.map(function (it) { return ids_1.indexOf(Number(it.referenceId)) >= 0 ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; })
                : [];
            var newResultsSale = state.availablePropertiesSale
                ? state.availablePropertiesSale.map(function (it) { return ids_1.indexOf(Number(it.referenceId)) >= 0 ? (__assign(__assign({}, it), { isSaved: action.payload.state })) : it; })
                : [];
            return __assign(__assign({}, state), { availablePropertiesRent: newResultsRent, availablePropertiesSale: newResultsSale });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setFullGalleryWidth): {
            return __assign(__assign({}, state), { galleryFullWidth: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setSaveSearchId): {
            return __assign(__assign({}, state), { saveSearchId: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setGalleryIndex): {
            return __assign(__assign({}, state), { galleryIndex: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.onFaqClicked): {
            var newFaqs = state.faqs.map(function (it, i) {
                if (i !== action.payload) {
                    return __assign(__assign({}, it), { opened: false });
                }
                return __assign(__assign({}, it), { opened: !it.opened });
            });
            return __assign(__assign({}, state), { faqs: newFaqs });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.onFollowPopupCloseClick): {
            return __assign(__assign({}, state), { followPopupActive: false });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setFollowPopupActive): {
            return __assign(__assign({}, state), { followPopupActive: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setGoogleMapReady): {
            return __assign(__assign({}, state), { mapReady: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.forceFactsViewMore): {
            return __assign(__assign({}, state), { factsMore: true });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.forceFeaturesViewMore): {
            return __assign(__assign({}, state), { featuresMore: true });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.forceAboutViewMore): {
            return __assign(__assign({}, state), { aboutMoreTextDisplay: !state.aboutMoreTextDisplay });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setVideoPopupActive): {
            return __assign(__assign({}, state), { isVideoPopActive: action.payload });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setIsPlaying): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { isPlaying: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setIsMuted): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { isMuted: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setCurrentTime): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { currentTime: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setTotalTime): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { totalTime: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setTargetCurrent): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { targetCurrent: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setVideoId): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { id: action.payload }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setVideoTitleCaption): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { title: action.payload.title, caption: action.payload.caption }) });
        }
        case typesafe_actions_1.getType(VideoAction_1.default.setVideoPlayerOverlayActive): {
            return __assign(__assign({}, state), { videoPlayer: __assign(__assign({}, state.videoPlayer), { overlayActive: action.payload }) });
        }
    }
    return state;
};
exports.placeReducer = function (state, action) { return (__assign(__assign({}, placeOnlyReducer(state, action)), { neighbourhood: NeighbourhoodReducer_1.neighbourhoodReducer(state.neighbourhood, action) })); };
